<script lang="ts" setup>
/* Types */
import { DateTimeChoices } from '@/store/basket/basket.types'
/* Stores */
import { useBasketTimeStore } from '@/store/basket/basket-time'

/* Components */
import BasketOnTimeSelects from '@/components/Basket/basket-time/BasketOnTimeSelects.vue'
const BasketWarningMessage = defineAsyncComponent(
  () => import('@/components/Basket/basket-utils/BasketWarningMessage.vue'),
)
const BasketErrorMessage = defineAsyncComponent(
  () => import('@/components/Basket/basket-utils/BasketErrorMessage.vue'),
)
const BasketTimeVariants = defineAsyncComponent(
  () => import('@/components/Basket/basket-time/BasketTimeVariants.vue'),
)

type Props = {
  errorMessage?: string
  warningMessage?: string
  warningIcon?: string
}
defineProps<Props>()

const emit = defineEmits(['update-time'])

const basketTime = useBasketTimeStore()

const dateChoices = ref<DateTimeChoices[]>([])
const selectedDate = ref('')
const selectedTime = ref('')

const updateCurrentTime = (deliveryAt: string) => {
  selectedTime.value = deliveryAt
  updateTime()
}

const getDateChoices = async () => {
  const dateChoicesResult = await basketTime.getDateChoices()

  selectedDate.value = dateChoicesResult[0].value
  dateChoices.value = dateChoicesResult || []
}

const getTimeChoices = async () => {
  selectedTime.value = ''

  await basketTime.getTimeChoices({
    date: selectedDate.value,
  })

  if (basketTime.choices && basketTime.choices[0]) {
    selectedTime.value = basketTime.choices[0].value
  }

  updateTime()
}

const updateTime = () => {
  if (!selectedTime.value) return

  emit('update-time', {
    delivery_at_client: true,
    delivery_at: selectedTime.value,
  })
}

onMounted(async () => {
  await getDateChoices()

  getTimeChoices()
})
</script>

<template>
  <div class="on-time">
    <basket-error-message
      v-if="errorMessage"
      :error-message="errorMessage"
      class="on-time__error"
    />

    <basket-on-time-selects
      v-model:selected-date="selectedDate"
      v-model:selected-time="selectedTime"
      :date-choices="dateChoices"
      :time-choices="basketTime.choices"
      :error-message="errorMessage"
      @get-time-choices="getTimeChoices"
      @update-time="updateTime"
    />

    <basket-warning-message
      v-if="warningMessage"
      :message="warningMessage"
      :icon="warningIcon"
    />

    <basket-time-variants
      v-if="basketTime?.variants.length"
      :variants="basketTime.variants"
      @set-time="updateCurrentTime"
    />
  </div>
</template>

<style lang="scss" scoped>
.on-time__error {
  margin-bottom: 30px;
}
</style>
